import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    container: {
      '&:hover': {
        border: "1px solid ".concat(token.colorPrimary),
        boxShadow: '0px 0px 0px 2px rgba(101, 187, 252, 0.2)'
      }
    },
    selector: {
      cursor: 'pointer',
      padding: '0 8px 0 12px'
    },
    counter: {
      width: '100%',
      '& > sup': {
        cursor: 'pointer',
        background: "".concat(token.colorPrimary, " !important")
      }
    },
    collector: {
      left: '24px !important'
    }
  };
});